module.exports = __webpack_public_path__ + "harbor-logo.c1c19546659d7b6cd864.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/harbor-logo.png
// module id = 931
// module chunks = 0